import { SubscriptionDetails } from '@/components/SubscriptionDetails';
import { LabradorComponent } from '@/types/component';

export const LabradorSubscriptionDetails: LabradorComponent = ({ data, type, meta, descendants, ...props }) => {
  return <SubscriptionDetails {...data} {...props} />;
};
